@if(isLogin){
<!-- header start -->
<app-header></app-header>
<!-- header end -->

<!-- main sidebar start -->
<app-sidebar></app-sidebar>
<!-- main sidebar end -->
}
<router-outlet></router-outlet>

<!-- footer start -->
<!-- <div class="footer">
    <p>Copyright©
        <script>document.write(new Date().getFullYear())</script> All Rights Reserved By <span
            class="text-primary">Safure</span>
    </p>
</div> -->
<!-- footer end -->